import React from "react";

import RequestsDashboard from "components/Dashboard/Requests";

const RequestsDashboardPage = () => {
  return <RequestsDashboard />;
};

export default RequestsDashboardPage;
